import React from "react";
import CrudPage from "./CrudPage";
import { useProfession } from "../lib/professions";

export function FixedCostsPage() {
  return (
    <CrudPage
      title="Custos Fixos"
      subtitle="Aluguel, luz, internet, impostos fixos, assinatura de softwares, etc."
      endpoint="fixed-costs"
      amountField="amount"
      dataTestId="fixed-costs"
      fields={[
        { name: "name", label: "Descrição", required: true, placeholder: "Ex: Aluguel" },
        { name: "amount", label: "Valor mensal (R$)", type: "number", required: true, format: "currency" },
        { name: "description", label: "Observações", hideInTable: true },
      ]}
    />
  );
}

export function VariableCostsPage() {
  return (
    <CrudPage
      title="Custos Variáveis"
      subtitle="Despesas que oscilam mês a mês: taxas, limpeza eventual, suprimentos de escritório."
      endpoint="variable-costs"
      amountField="amount"
      dataTestId="variable-costs"
      fields={[
        { name: "name", label: "Descrição", required: true },
        { name: "amount", label: "Valor médio mensal (R$)", type: "number", required: true, format: "currency" },
        { name: "description", label: "Observações", hideInTable: true },
      ]}
    />
  );
}

export function MaterialsPage() {
  return (
    <CrudPage
      title="Materiais"
      subtitle="Insumos utilizados nos procedimentos. Informe o custo e a quantidade da embalagem."
      endpoint="materials"
      dataTestId="materials"
      fields={[
        { name: "name", label: "Material", required: true, placeholder: "Ex: Resina composta" },
        { name: "unit", label: "Unidade", placeholder: "un, g, ml", default: "un" },
        { name: "package_cost", label: "Custo da embalagem (R$)", type: "number", required: true, format: "currency" },
        { name: "package_quantity", label: "Qtd. por embalagem", type: "number", required: true, default: 1 },
        { name: "description", label: "Observações", hideInTable: true },
      ]}
    />
  );
}

export function EmployeesPage() {
  return (
    <CrudPage
      title="Funcionários"
      subtitle="Equipe fixa (recepção, auxiliar). Encargos trabalhistas são considerados no cálculo."
      endpoint="employees"
      dataTestId="employees"
      fields={[
        { name: "name", label: "Nome", required: true },
        { name: "role", label: "Cargo", required: true, placeholder: "Ex: Auxiliar" },
        { name: "salary", label: "Salário (R$)", type: "number", required: true, format: "currency" },
        { name: "charges_percentage", label: "Encargos (%)", type: "number", suffix: "%", default: 70 },
      ]}
    />
  );
}

export function ProfessionalsPage() {
  const prof = useProfession();
  return (
    <CrudPage
      title="Profissionais"
      subtitle={`${prof.label}s e demais profissionais da sua ${prof.place}. Defina o valor que recebem por hora de atendimento.`}
      endpoint="professionals"
      dataTestId="professionals"
      fields={[
        { name: "name", label: "Nome", required: true },
        { name: "specialty", label: "Especialidade", default: prof.label },
        { name: "hourly_rate", label: "Valor por hora clínica (R$)", type: "number", required: true, format: "currency" },
        { name: "commission_percentage", label: "Comissão adicional (%)", type: "number", suffix: "%", default: 0 },
      ]}
    />
  );
}
